import $ from 'jquery';
import { getStorage } from '../../../home24/helpers/storage-factory';
import { getCurrentDataLayer } from '../common/helper';
import { getBaseUrl } from '../../../home24/core/config';

class PageVisit {
  constructor(model) {
    this.model = model;
    this.onClick = this.onClick.bind(this);
  }

  setupEvents() {
    $('#pdp-app-root').on('click', '[data-gtm-bind-click]', this.onClick);
  }

  onClick(event) {
    const $currentTarget = $(event.currentTarget);
    const dataAttributes = $currentTarget.data();

    this.storeTrackingData({
      sku: dataAttributes.sku,
      position: dataAttributes.position,
      recommendationId: dataAttributes.recommendationId,
      source: this.getEventSource($currentTarget)
    });
  }

  // This method must be present to be identified as a tracker. Usually you
  // extend a base-tracking, but in our case we want a different
  // implementation.
  executeCookieCallbacks() {
    const storedTrackingData = this.popStoredTrackingData();
    const trackingData = this.model.get('trackingData');

    if (!trackingData) {
      return;
    }

    const { recommendationId } = storedTrackingData;
    this.pushClickToDataLayer({
      ...trackingData,
      recommendationId: recommendationId ? recommendationId : null,
      position: storedTrackingData.position,
      source: storedTrackingData.source
    });

    $.post(`${getBaseUrl()}/article/recordvisit`, {
      sku: trackingData.sku,
      recommendationId: storedTrackingData.recommendationId
    });
  }

  pushClickToDataLayer(trackingData) {
    if (typeof window.dataLayer !== 'object') {
      return;
    }

    const productData = {
      name: trackingData.name,
      id: trackingData.sku,
      price: trackingData.price,
      brand: trackingData.brand,
      category: trackingData.category,
      variant: trackingData.variant,
      dimension64: trackingData.deliveryTime,
      position: trackingData.position
    };

    if (trackingData.productCampaigns) {
      productData.productCampaigns = trackingData.productCampaigns;
    }

    if (trackingData.recommendationId) {
      productData.recommendationID = trackingData.recommendationId;
    }

    window.dataLayer.push({
      event: 'productClick',
      ecommerce: {
        click: {
          actionField: {
            list: trackingData.source
          },
          products: [productData]
        }
      }
    });
  }

  storeTrackingData(data) {
    const storage = getStorage();
    storage.set('GtmOnArticleClicked', data);
  }

  popStoredTrackingData() {
    const storage = getStorage();
    const storedTrackingData = storage.get('GtmOnArticleClicked');

    if (storedTrackingData) {
      storage.unset('GtmOnArticleClicked');
    }

    return storedTrackingData || {};
  }

  getEventSource($element) {
    let source =
      $element.data('gtmEventSource') ||
      $element.closest('[data-gtm-event-source]').data('gtmEventSource');

    // add category name if available
    const categoryName = getCurrentDataLayer().pageProdGroup;

    if (categoryName) {
      // ie. 'Catalog - Möbel'
      source = source + ' - ' + categoryName;
    }

    return source;
  }
}

// Backbone.Model is also compatible with this Model
export class Model {
  constructor(vals = {}) {
    this.vals = vals;
  }

  set(vals) {
    this.vals = { ...this.vals, ...vals };
  }

  get(key) {
    return this.vals[key];
  }
}

export default PageVisit;



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/tracking/pdp/PageVisit.js
 **/